module.exports = __webpack_public_path__ + "img/bodytalkcourses.f3c5e346.svg";